module.exports = __webpack_public_path__ + "static/parade-2020-house11-c21a46766686a986f024823254058a01.jpg";